import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';

import { AutoFormik } from '@portals/autoformik';

const FIELDS = [
  { name: 'name', title: 'Card owner name', required: true },
  { name: 'card', title: 'Card number', required: true },
];

const PurchaseProduct = ({ closeMe }) => {
  const [count, setCount] = useState(1);

  return (
    <Modal isOpen={true} toggle={closeMe} centered>
      <ModalHeader toggle={closeMe}>Add License</ModalHeader>

      <ModalBody>
        <Table size="sm" className="my-2" borderless>
          <tbody>
            <tr>
              <th>Partner</th>
              <th>Product</th>
              <th>License type</th>
              <th>Price</th>
              <th>Count</th>
              <th />
            </tr>
            <tr>
              <td>Xyte</td>
              <td>BrightSign</td>
              <td>Single device</td>
              <td>$1 / month</td>
              <td>{count}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => setCount(count + 1)}
                  className="mr-2"
                >
                  +
                </Button>
                <Button size="sm" onClick={() => setCount(count - 1)}>
                  -
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>

      <AutoFormik
        fields={FIELDS}
        inProgress={false}
        handleSubmit={console.log}
        modal={closeMe}
        submitTitle="Purchase"
      />

      <ModalBody className="pt-0">
        <div className="text-right font-size-lg text-dark">
          Total: <strong>${count}</strong> / month
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PurchaseProduct;
